/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */
import { ApiResParserService } from '@api/services/api-res-parser/api-res-parser.service';
import { ApiService } from '@api/services/api/api.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ApiMockService extends ApiService {
  constructor(
    protected http: HttpClient,
    protected parser: ApiResParserService
  ) {
    super(http, parser);
  }
}
